import { type GenerateQSetErrorCode } from '../../types';

export const ERROR_CODE_TO_MESSAGE: Record<GenerateQSetErrorCode, string> = {
  DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND:
    'เนื่องจากมี LOS ที่ถูกปิดใช้งาน ทำให้ข้อสอบในคลังไม่เพียงพอในการสร้างชุดข้อสอบ',
};
